export const environment = {
    isDev: true,
    translationUrl: "/translations/",
    backendHost: "https://api-dev-wbe.hotellinx.com",
    paymentEndpoint: "https://api-dev-payment.hotellinx.com",
    apiKey: 'pU!OXohFL4b*C6jeC&Co13Z8Z8mn*M',
    software: 6
}
